import * as angular from 'angular';
import { ForgotPassword } from '../../../core';
import { AccountService } from '../../account.service';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';

export class ForgotPasswordController {

    static $inject = ['accountService', 'notificationService', 'definitionsService', '$translate', '$state'];
    email: string;
    waiting: boolean;
    submitted: boolean;
    emailPattern: RegExp;
    forgotPasswordForm: ng.IFormController;

    constructor(
        private accountService: AccountService,
        private notificationService: NotificationService,
        private definitionsService: DefinitionsService,
        private $translate: angular.translate.ITranslateService,
        private $state: StateService
    ) {
        this.email = null;
        this.waiting = false;
        this.submitted = false;
        this.emailPattern = definitionsService.regexEmail;
    }

    submit = async () => {
        this.submitted = true;

        if (this.forgotPasswordForm.$invalid) {
            return;
        }

        this.notificationService.showWaitingMessage();

        let model: ForgotPassword = { Email: this.email };
        try {
            await this.accountService.forgotPassword(model);
            this.notificationService.clearAll();
            this.$state.go('account.resetSuccess');
            // this.notificationService.showSuccessMessage({
            //     title: this.$translate.instant('reset_link_sent'),
            //     body: this.$translate.instant('reset_link_hint'),
            //     timeout: 8000
            // });
        } catch (error) {
            this.notificationService.showErrorMessage(error);

        }
        this.waiting = false;
    }
}

angular.module('naut')
    .component('forgotPassword', {
        template: require('./forgotPassword.html'),
        controller: ForgotPasswordController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/forgotPassword/forgotPassword.component.ts